export default __webpack_public_path__ + "static/media/01.e12bc038.png";